import * as React from "react";
const SvgCloseIcon = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L13 13M13 1L1 13" }));
export default SvgCloseIcon;
